var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUsers2 = function SvgUsers2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.375 7.875V7.125C6.375 6.72718 6.21696 6.34564 5.93566 6.06434C5.65436 5.78304 5.27282 5.625 4.875 5.625H1.875C1.47718 5.625 1.09564 5.78304 0.81434 6.06434C0.533035 6.34564 0.375 6.72718 0.375 7.125V7.875",
    stroke: "#6280DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.375 4.125C4.20343 4.125 4.875 3.45343 4.875 2.625C4.875 1.79657 4.20343 1.125 3.375 1.125C2.54657 1.125 1.875 1.79657 1.875 2.625C1.875 3.45343 2.54657 4.125 3.375 4.125Z",
    stroke: "#6280DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 7.87508V7.12508C8.62475 6.79273 8.51413 6.46987 8.31051 6.2072C8.10689 5.94452 7.8218 5.75692 7.5 5.67383",
    stroke: "#6280DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1.17383C6.32266 1.25644 6.60864 1.44409 6.81286 1.70719C7.01709 1.9703 7.12794 2.29389 7.12794 2.62695C7.12794 2.96002 7.01709 3.28361 6.81286 3.54671C6.60864 3.80982 6.32266 3.99747 6 4.08008",
    stroke: "#6280DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsers2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users2.8b183f07.svg";
export { ForwardRef as ReactComponent };